import React, { useState } from 'react';
import './Dialogs/WorkflowPublishConfirmDialog.css';

function WorkflowPublishComment({ setPublishComment }) {
  const [comment, setComment] = useState('');

  return (
    <div className="publish-comment-section">
      <p className="publish-comment-label">Version Notes (optional)</p>
      <textarea
        className="publish-comment-textarea"
        value={comment}
        onChange={e => setComment(e.target.value)}
        onBlur={() => setPublishComment(comment)}
        placeholder="Add notes describing changes in this version..."
        maxLength={500}
      />
    </div>
  );
}

export default WorkflowPublishComment;
